module.exports = __webpack_public_path__ + "static/media/tap-creative.7be8d479.png";